<template>
  <div>
    <CButton
      :disabled="this.$store.getters['profile/getUserType']===10"
      @click="changeStatus"
      class="btn-change"
      style="font-weight: bold; background-color: #0080FF;border-radius:0.5rem;color:white"
    >CHANGE</CButton>

    <!-- Modal for change email -->
    <CModal :centered="true" :show.sync="openModal" add-content-classes="bg-transparent border-0" :closeOnBackdrop="false">
      <template #header-wrapper>
        <div class="closeBtnContainer">
          <p class="closeButton">
            <img
              @click="openModal= false"
              src="@/assets/icons/closeButton.svg"
              style="background-color: white; border-radius: 50%;"
            />
          </p>
        </div>
      </template>
      <template #body-wrapper>
        <div class="completeContainer">
          <CCol style="align-items: center">
            <CRow class="title">
              <label>{{ data.title }}</label>
            </CRow>
            <CRow
              class="content"
              style="padding-left: 2.5rem;padding-right: 2.5rem; font-family: Roboto;"
            >
              <label>{{ data.description }}</label>
            </CRow>
            <CRow class="completeButton">
              <input v-model="data.inputText" class="textInput" :placeholder="data.placeholder" />
            </CRow>
            <CRow class="completeButton" style="margin-top: 2rem">
              <CButton
                @click="openModal= false"
                style="background-color:#B2B2B2;color:white;font-weight:bold;border-radius:24px;width:32%;margin-right:0.5rem"
              >CANCEL</CButton>
              <CButton
                @click="openNextModal"
                style="background-color:#0080FF;color:white;font-weight:bold;border-radius:24px;width:32%;margin-left:0.5rem"
              >CONFIRM</CButton>
            </CRow>
          </CCol>
        </div>
      </template>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>

    <!-- Modal for verify -->
    <CModal
      :centered="true"
      :no-close-on-backdrop="true"
      :show.sync="openVerify"
      add-content-classes="bg-transparent border-0"
      :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="closeBtnContainer">
          <p class="closeButton">
            <img
              @click="openVerify=false"
              src="@/assets/icons/closeButton.svg"
              style="background-color: white; border-radius: 50%;"
            />
          </p>
        </div>
      </template>
      <template #body-wrapper>
        <CCol class="completeContainer" style="align-items: center">
          <CRow class="title">
            <label class="textButtonFont" style="font-weight: bold">CONFIRM VERIFY CODE</label>
          </CRow>

          <CRow class="completeButton" style="margin-top: 1rem">
            <input class="textInput textButtonFont" placeholder="Enter your verify code" />
          </CRow>
          <CRow
            class="text-danger"
            style="justify-content: flex-end;width: 96%;margin-bottom: 1rem"
          >
            <label
              class="textButtonFont"
              style="border-bottom: 1px solid black; font-size: 0.75rem;color: black;font-style: italic;font-weight: bold"
            >
              Didn't
              get one?
            </label>
          </CRow>

          <CRow class="completeButton">
            <CButton
              @click="openNextNextModal"
              class="textButtonFont"
              style="background-color:#0080FF; color:white; font-weight: bold;border-radius: 24px;width: 40%"
            >Submit</CButton>
          </CRow>
        </CCol>
      </template>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>

    <!-- Modal for display complete -->
    <CModal
      :centered="true"
      :no-close-on-backdrop="true"
      :show.sync="updateDataSuccess"
      add-content-classes="bg-transparent border-0"
      :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div @click="loginModal=false" class="closeBtnContainer">
          <p class="closeButton">
            <img
              @click="updateDataSuccess=false"
              src="@/assets/icons/closeButton.svg"
              style="background-color: white; border-radius: 50%;"
            />
          </p>
        </div>
      </template>
      <template #body-wrapper>
        <div class="completeContainer">
          <CCol style="align-items: center">
            <CRow class="title">
              <label class="textButtonFont" style="font-weight: bold">COMPLETE!</label>
            </CRow>
            <CRow class="content">
              <label class="textButtonFont">{{ data.completedDescription }}</label>
            </CRow>
            <CRow class="completeButton">
              <CButton
                @click="acceptConfirm"
                class="textButtonFont"
                style="border-radius: 24px;width: 40%;background-color: #0080FF;color: white;font-weight: bold"
              >OK</CButton>
            </CRow>
          </CCol>
        </div>
      </template>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    updateDataSuccess: Boolean,
  },
  data() {
    return {
      openModal: false,
      openVerify: false,
    };
  },
  methods: {
    changeStatus() {
      this.openModal = !this.openModal;
    },
    openNextModal() {
      (this.openModal = false),
        (this.openVerify = false),
        this.$emit("confirm", this.data.inputText);
    },
    openNextNextModal() {
      this.openVerify = false;
    },
    acceptConfirm() {
      this.updateDataSuccess = false;
    },
  },
  mounted() {
  },
  // name: "changeEmail",
  // props:{
  //     openChange:Boolean,
  // },
  // created(){
  // },
  // data() {
  //     return {
  //         open: this.openChange,
  //     }
  // }
};
</script>

<style>
.btn-change {
  width: 150px;
  height: 50px;
  font-weight: bold;
  background-color: #0080ff;
  border-radius: 0.5rem;
  color: white;
}
</style>

<style scoped>
.textButtonFont {
  font-family: Roboto;
}

.closeBtnContainer {
  padding-right: 1rem;
}

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.completeContainer {
  width: 80%;
  border-radius: 20px;
  background-color: white;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
  align-self: center;
}

.title {
  color: black;
  justify-content: center;
  font-family: Roboto;
  margin-bottom: 0.8rem;
  font-size: 1.28rem;
}

.content {
  color: black;
  justify-content: center;
  font-family: "Roboto Light";
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.completeButton {
  justify-content: center;
}

.textInput {
  border: 0px;
  border-bottom: 1px solid #ccc;
  width: 80%;
}
@media only screen and (max-width: 450px) {
  .btn-change {
    width: 87px;
    height: 40px;
    margin-top: 0.5em;
    margin-left: 1.5em;
    font-size: 14px;
  }
}
</style>
